import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Spinner, EmptyState, AlertCircle, Button } from '@opendate-app/setlist';
import client from '../../../shared/api/client';
import MapWithMarkerClusters from '../../MapWithMarkerClusters/components/MapWithMarkerClusters';

export default function WhereFromCard({ insights, insightsError, geoCoordinatesUrl }) {
  const [showMap, setShowMap] = useState(false);
  const [coords, setCoords] = useState(null);
  const markets = insights && insights.markets ? insights.markets : [];
  const maxCount = markets.reduce((max, row) => Math.max(max, row.count), 0);

  const openMap = () => {
    setShowMap(true);
    if (!coords) {
      client.get(geoCoordinatesUrl)
        .then((res) => setCoords(res.data))
        .catch(() => {
          setShowMap(false);
          toast.error("Couldn't load the map.");
        });
    }
  };

  return (
    <Card padding="md">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>Where they come from</h2>
        {!insightsError && insights && (
          showMap ? (
            <Button variant="tertiary" size="sm" onClick={() => setShowMap(false)}>View list</Button>
          ) : (
            <Button variant="tertiary" size="sm" onClick={openMap}>Open map view</Button>
          )
        )}
      </div>
      {showMap && !insightsError && insights ? (
        coords ? (
          <MapWithMarkerClusters geoCoordinates={coords} height="360px" lat="39.5" lon="-98.35" />
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
            <Spinner label="Loading…" />
          </div>
        )
      ) : insightsError ? (
        <EmptyState
          size="sm"
          icon={AlertCircle}
          title="Couldn't load markets"
          description="Refresh the page to try again."
        />
      ) : !insights ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spinner label="Loading…" />
        </div>
      ) : markets.length === 0 ? (
        <EmptyState size="sm" title="No market data yet" />
      ) : (
        markets.map((row) => (
          <div key={row.name} style={{ padding: '8px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 4 }}>
              <span style={{ fontWeight: 600 }}>{row.name}</span>
              <span style={{ color: 'var(--sl-text-quaternary, #717680)' }}>{row.count}</span>
            </div>
            <div style={{ height: 6, borderRadius: 3, background: 'var(--sl-bg-secondary, #f2f4f7)' }}>
              <div
                style={{
                  height: '100%',
                  borderRadius: 3,
                  background: 'var(--sl-fg-brand)',
                  width: `${maxCount === 0 ? 0 : (row.count / maxCount) * 100}%`,
                }}
              />
            </div>
          </div>
        ))
      )}
    </Card>
  );
}
